import { Outlet, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useScreeningStore } from '../../state/store'
import { useGetScreeningStatusQuery } from '../../api/ester-b2b-api/private/screening/screeningQueries'

export const PortalLayout = () => {
  const location = useLocation()
  const { data: fetchedScreeningData, refetch, isSuccess, dataUpdatedAt } = useGetScreeningStatusQuery()
  const { setScreeningData } = useScreeningStore()

  // dataUpdatedAt is load-bearing, not a stray dep — please don't "clean it up". react-query's
  // structural sharing hands back the *same* object reference when a refetch returns deep-equal data,
  // so after a screeningStore.resetState() (see ScreeningShared.tsx) the deps would be unchanged, the
  // effect would never re-run, and the store would stay undefined while the query holds valid data.
  useEffect(() => {
    if (isSuccess) {
      setScreeningData(fetchedScreeningData)
    }
  }, [fetchedScreeningData, dataUpdatedAt, isSuccess, setScreeningData])

  useEffect(() => {
    if (location.pathname.includes('/screening')) {
      refetch()
    }
  }, [location.pathname, refetch])

  return <Outlet />
}
